<template>
  <div class="iframe-container">
    <iframe :src="viewerUrl" frameBorder="0" class="h-100 w-100"></iframe>
  </div>
</template>

<script>
import { mapState } from "vuex";
import config from "../../server/serverCfg";

export default {
  name: "ReportViewer",
  props: ["report", "isCustom"],
  computed: {
    ...mapState("layout", {
      systemSetting: state => state.systemSetting
    }),
    viewerUrl() {
      return `${this.systemSetting.reportUrl}/#/viewer${
        this.isCustom ? "-custom" : ""
      }/${this.report}/${config.token}`;
    }
  }
};
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 166px);
}
</style>
